import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {DateAdapter} from '@angular/material/core';
import {Subject} from 'rxjs';
import * as moment from 'moment';
import {MomentAdapter} from '../../../shared/utils/moment.utils';

@Component({
    selector: 'app-date-picker',
    templateUrl: './date-picker.component.html',
    styleUrls: ['./date-picker.component.scss'],
})
export class DatePickerComponent implements OnInit, OnDestroy{
    @Input() parentFormGroup: UntypedFormGroup;
    @Input() parentFormControlName: string;
    @Input() birthDate = false;
    @Input() label: string;
    @Output() dateChangedEvent = new EventEmitter<moment.Moment>();
    maximumDate: moment.Moment;
    minimumDate: moment.Moment;

    /** Subject that emits when the component has been destroyed. */
    private onDestroy = new Subject<void>();

    constructor(private adapter: DateAdapter<any>) {
        this.adapter.setLocale('fr-BE');
    }

    ngOnInit(): void {
        if (this.birthDate) {
            this.maximumDate = MomentAdapter.current().get();
            this.minimumDate = MomentAdapter.current().subtractYears(120).get();
        }
    }

    ngOnDestroy(): void {
        this.onDestroy.next();
        this.onDestroy.complete();
    }
}
